import { render, staticRenderFns } from "./AdminGliderMenu.vue?vue&type=template&id=1a033398"
import script from "./AdminGliderMenu.vue?vue&type=script&lang=ts"
export * from "./AdminGliderMenu.vue?vue&type=script&lang=ts"
import style0 from "./AdminGliderMenu.vue?vue&type=style&index=0&id=1a033398&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports